export default __webpack_public_path__ + "static/media/sudoku.aea0f389.png";